import { ref, readonly } from 'vue';
import { get, ENDPOINTS } from '@/api/mainApi';
import store from '@/store';
import { DonationImageCategory } from '@/interfaces/donation/donationImageCategory';

export function useImageOperations() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const fetchImagesAndCategories = async (organizationGroupId?: number) => {
    loading.value = true;
    error.value = null;

    try {
      // If organizationGroupId is provided, filter by it, otherwise fetch all images
      const params = organizationGroupId ? { organizationGroupId } : {};

      const [categoriesRes, imagesRes] = await Promise.all([
        get(ENDPOINTS.IMAGE_CATEGORIES, params),
        get(ENDPOINTS.IMAGES, params),
      ]);

      // Sort categories by organizationGroupId (nulls first)
      if (categoriesRes) {
        categoriesRes.sort((a: DonationImageCategory, b: DonationImageCategory) => {
          const aComp = a.organizationGroupId == null ? 0 : 1;
          const bComp = b.organizationGroupId == null ? 0 : 1;
          return bComp - aComp;
        });
      }

      return {
        categories: categoriesRes || [],
        images: imagesRes || [],
      };
    } catch (err) {
      error.value = 'Failed to fetch images and categories';
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    fetchImagesAndCategories,
  };
}
